import { HttpErrorResponse } from '@angular/common/http';

export function errorFromHttpErrorResponse(
  err: HttpErrorResponse,
  options?: {
    defaultMessage?: string;
    separator?: string;
  }
): string {
  let errorMessage = options?.defaultMessage ?? 'NOTIFICATION.ERROR_DATA';
  if (Array.isArray(err.error) && err.error.length > 0 && err.error.every((value) => typeof value === 'string')) {
    errorMessage = err.error.join(options?.separator ?? ', ');
  } else if (typeof err.error === 'string') {
    errorMessage = err.error;
  } else if (err.message) {
    errorMessage = err.message;
  }
  return errorMessage;
}
